module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.getCover()) ? _c('div', {
    staticClass: "cover",
    style: ({
      backgroundImage: 'url(' + _vm.getCover() + ')'
    })
  }) : _c('div', {
    staticClass: "cover",
    style: ({
      backgroundImage: 'url(' + require('@/assets/images/faces/default-cover.png') + ')'
    })
  }), _c('div', {
    staticClass: "edit-cover",
    style: ({
      backgroundImage: 'url(' + require('@/assets/images/faces/ic_camera.svg') + ')'
    }),
    on: {
      "click": function($event) {
        return _vm.changeAvatar(false)
      }
    }
  }), _c('div', {
    staticClass: "profile-content"
  }, [_c('div', {
    staticClass: "card-avatar"
  }, [(!_vm.getAvatar()) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/faces/ic_AvatarDefault.svg")
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.user.avatar
    }
  })]), _c('div', {
    staticClass: "edit-avatar"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/faces/ic_camera.svg")
    },
    on: {
      "click": function($event) {
        return _vm.changeAvatar(true)
      }
    }
  })]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "hat-teacher"
  }, [(_vm.user.type_user === 2) ? _c('div', {
    staticClass: "img-fullname"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/faces/ic_giaovien.svg")
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "fullname",
    style: (_vm.user.type_user === 2 ? 'padding-left: 10px;' : '')
  }, [_vm._v(_vm._s(_vm.user.fullname))])]), _c('div', {
    staticClass: "userquotes"
  }, [_vm._v(_vm._s(_vm.user.userquotes))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-145f65f8","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserProfile/avatar.vue
// module id = 1490
// module chunks = 0